import { useState, useContext, useEffect, useCallback } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
} from '@panwds/react-ui'
import { LoadingIcon, Body, Input } from '@panwds/react-ui'
import { isEmpty } from 'lodash'
import {
  PANORAMA_OTP_MODAL_TITLE
} from '../../constants/LabelConstants'
import SubscriptionService from '../../../subscription/services/SubscriptionService'
import AuthContext from '../../../common/context/AuthContext'
import { getSignature } from '../../../common/utils/Utils'

/**
 * A Modal to display and copy panorama one time password
 * @returns {JSX.Element}
 * @constructor
 */

const OTPBody = ({ otp = {} }) => {
  if (isEmpty(otp) || otp.error) {
    return (
      <div className="tw-flex tw-flex-col tw-space-x-1">
        <Body as="span" size="lg">OTP for Primary Panorama</Body>
        <Input readOnly allowCopy appearance="error" value={otp?.error || 'OTP generation failed'} />
      </div>
    )
  }
  const NAMES = ['Primary', 'Secondary']
  return Object.values(otp).map((each, index) => {
    const validUntil = new Date(each.otp_expiration)
    return (
      each && <div key={index} className="tw-flex tw-flex-col tw-space-x-1">
        <Body as="span" size="lg">{`OTP for ${NAMES[index]} Panorama`}</Body>
        <Input readOnly allowCopy appearance="success" value={each.otp} />
        <Body as="span">Valid until {validUntil.toLocaleTimeString()}</Body>
      </div>
    )
  }).filter(Boolean)
}

const PanoramaOTPModal = ({ closeModal, isOpen, data }) => {
  const { user } = useContext(AuthContext)
  const [isLoading, setLoading] = useState(true)
  const [otpResp, setOtp] = useState({})

  const loadOtp = useCallback(async () => {
    const { support_account_id, serial_number, tsg_id, tenant_id } = data
    const signature = getSignature(+support_account_id, user?.supportAccountIds)
    if (!signature) {
      // user doesn't have that csp account registered with panorama
      setLoading(false)
      setOtp({
        error: `You don't have access for this supported account id:${support_account_id}, please contact support team`
      })
      return
    }
    const notonorafter = user?.notonorafter
    const xsig = `${support_account_id} ${notonorafter} ${signature}`
    try {
      const { data: resp } = await SubscriptionService.devices.generatePanoramaOTP({
        support_account_id,
        sn: serial_number || tenant_id, // due to one of the bug some older Panorama dont have sn hence we use tenant_id
        tsg_id,
        xsig,
      })
      setLoading(false)
      setOtp(resp)
    }
    catch (e) {
      setLoading(false)
      setOtp({})
    }
  }, [data, user])

  useEffect(() => {
    setLoading(true)
    loadOtp()
    return () => {
      setLoading(false)
    }
  }, [loadOtp])

  return (
    <Modal size='md' onClose={closeModal} isOpen={isOpen} style={{ minHeight: 130 }}>
      <ModalHeader title={PANORAMA_OTP_MODAL_TITLE} />
      <ModalBody addClassName='tw-overflow-auto'>
        {isLoading ?
          <LoadingIcon /> :
          <OTPBody otp={otpResp} />
        }
      </ModalBody>
    </Modal>
  )
}

PanoramaOTPModal.propTypes = {}
export default PanoramaOTPModal

